module.exports = __webpack_public_path__ + "img/memolog.78b3f0fe.png";